import React from 'react';
import { TruckIcon, LeafIcon, MessageCircleIcon, SparklesIcon } from 'lucide-react';
const badges = [{
  icon: TruckIcon,
  label: 'Gratis verzending vanaf € 100'
}, {
  icon: LeafIcon,
  label: '100% vegan, dierproefvrij, boom per product'
}, {
  icon: MessageCircleIcon,
  label: 'Persoonlijk advies via WhatsApp'
}, {
  icon: SparklesIcon,
  label: '20+ jaar huidexpertise'
}];
export function TrustBadges({
  tone = 'sand'
}: {
  tone?: 'sand' | 'shell';
}) {
  return <section aria-label="Onze beloftes" className={`border-y border-line ${tone === 'sand' ? 'bg-sand' : 'bg-shell'}`} data-id="element-258" data-mp="3cducbiynhlpx">
      <div className="mx-auto grid max-w-content gap-x-8 gap-y-4 px-6 py-6 sm:grid-cols-2 lg:grid-cols-4 lg:px-10" data-id="element-259" data-mp="3l8qu2zwfs6pe">
        {badges.map(({
        icon: Icon,
        label
      }) => <div key={label} className="flex items-center gap-3" data-id="element-260" data-mp="3v6ofzgqtpreu">
            <Icon className="h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} data-id="element-261" data-mp="3v76nj9ixrs22" />
            <span className="text-[13px] leading-snug text-muted" data-id="element-262" data-mp="3q8mwwvteds3d">{label}</span>
          </div>)}
      </div>
    </section>;
}